import React from 'react';
import * as Lucide from 'lucide-react';

// T0 — Résout une icône lucide par son nom (string). Fallback sûr si le nom est inconnu.
// Permet de piloter les icônes depuis les données JSON et les tokens sans maintenir de map.
export const Icon = ({ name, ...props }) => {
  const Cmp = (name && Lucide[name]) || Lucide.Square;
  return <Cmp {...props} />;
};

export default Icon;
